// extracted by mini-css-extract-plugin
export var cookiesSection = "fn_Ly";
export var cookiesSection__btn = "fn_LC";
export var cookiesSection__link = "fn_LB";
export var cookiesSection__text = "fn_Lz";
export var cookiesSection__wrapper = "fn_Lx";